// removed by extract-text-webpack-plugin
module.exports = {"button":"button_3ka","buttonImg":"buttonImg_2xe","buttonContent":"buttonContent_6iK","buttonBig":"buttonBig_3Bk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/button/button.scss
// module id = 473
// module chunks = 0 1